/**
 * @generated SignedSource<<de15f20035b5fbdb87a269694e6f6ef3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueTypesDialogIssueTypes$data = {
  readonly nodes: ReadonlyArray<{
    readonly isEnabled: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"IssueTypeEntry">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "IssueTypesDialogIssueTypes";
};
export type IssueTypesDialogIssueTypes$key = {
  readonly " $data"?: IssueTypesDialogIssueTypes$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTypesDialogIssueTypes">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueTypesDialogIssueTypes",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueType",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "IssueTypeEntry"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IssueTypeConnection",
  "abstractKey": null
};

(node as any).hash = "bc0d66cc250f97d432922d449d5cfb3c";

export default node;
